import { render, staticRenderFns } from "./TrainPadGameSort.vue?vue&type=template&id=f2477e78&scoped=true&"
import script from "./TrainPadGameSort.vue?vue&type=script&lang=js&"
export * from "./TrainPadGameSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2477e78",
  null
  
)

export default component.exports